import "@/sim/sim.css";
import { useNavigate } from "react-router-dom";
import { Radar as RadarIcon, ArrowUpRight, ArrowLeft, ShieldCheck, LogOut } from "lucide-react";
import { useSimAuth } from "@/sim/SimGate";

export function SimLayout({ children, maxWidth = "max-w-7xl" }) {
  const navigate = useNavigate();
  const { user, logout } = useSimAuth();

  return (
    <div className="sim-root">
      <header className="sim-glass sticky top-0 z-50">
        <div className={`${maxWidth} mx-auto px-5 h-14 flex items-center justify-between`}>
          <div className="flex items-center gap-3">
            <a
              href="/"
              data-testid="sim-to-main-link"
              className="hidden sm:flex items-center gap-1 sim-mono text-[11px] text-[#9AA0AC] hover:text-[#00F0FF] transition-colors"
              title="Back to ROAS-AI"
            >
              <ArrowLeft className="w-3 h-3" /> ROAS-AI
            </a>
            <span className="hidden sm:block w-px h-4 bg-[#27272A]" />
            <button
              data-testid="sim-logo"
              onClick={() => navigate("/sim")}
              className="flex items-center gap-2.5 group"
            >
              <div className="w-7 h-7 rounded-md bg-[#00F0FF]/10 border border-[#00F0FF]/30 flex items-center justify-center">
                <RadarIcon className="w-4 h-4 text-[#00F0FF]" />
              </div>
              <span className="sim-head text-[15px] font-extrabold text-[#F5F5F5] tracking-tight">
                sim<span className="text-[#00F0FF]">.</span>roas-ai
              </span>
            </button>
          </div>

          <div className="flex items-center gap-2">
            {user?.is_admin && (
              <button
                data-testid="sim-admin-link"
                onClick={() => navigate("/sim/admin")}
                className="hidden sm:flex items-center gap-1.5 sim-mono text-[11px] text-[#C2C5CE] hover:text-[#F5F5F5] border border-[#27272A] hover:border-[#3f3f46] px-2.5 py-1.5 rounded transition-colors"
              >
                <ShieldCheck className="w-3 h-3" /> ADMIN
              </button>
            )}
            <button
              data-testid="sim-new-run"
              onClick={() => navigate("/sim")}
              className="sim-mono text-[11px] text-[#0A0A0A] bg-[#00F0FF] hover:bg-[#33f3ff] font-bold px-3 py-1.5 rounded transition-colors flex items-center gap-1"
            >
              NEW SIM <ArrowUpRight className="w-3 h-3" />
            </button>
            {user && (
              <div className="flex items-center gap-2 pl-1" data-testid="sim-user-chip">
                <div className="w-7 h-7 rounded-full bg-[#1A1A1A] border border-[#27272A] flex items-center justify-center overflow-hidden">
                  {user.picture ? (
                    <img src={user.picture} alt={user.name || user.email} className="w-full h-full object-cover" referrerPolicy="no-referrer" />
                  ) : (
                    <span className="sim-mono text-[11px] text-[#C2C5CE]">{(user.email || "?")[0].toUpperCase()}</span>
                  )}
                </div>
                <button
                  data-testid="sim-logout-btn"
                  onClick={logout}
                  title="Sign out"
                  className="w-7 h-7 rounded flex items-center justify-center text-[#9AA0AC] hover:text-[#EF4444] hover:bg-[#EF4444]/10 transition-colors"
                >
                  <LogOut className="w-3.5 h-3.5" />
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
      <main className={`${maxWidth} mx-auto px-5 py-6`}>{children}</main>
    </div>
  );
}
